module.exports = __webpack_public_path__ + "static/media/Circle_Jaffa.4418c1ca.svg";